module.exports = __webpack_public_path__ + "static/media/godown.f3e47aea.gif";